module.exports = __webpack_public_path__ + "img/pedro.1b55d92.svg";